import $ from 'jquery';

import ch_collection from 'collections/coachhub';
import coachModel from 'models/coach';


export default ch_collection.extend({
  url: COACHES_API_URL,
  model: coachModel,
  get_coach_by_user_id: function (user_id) {
    var coaches = this.filter(function (coach) {
      return coach.get('user').id == user_id;
    });
    return coaches.length > 0 ? coaches[0] : null;
  }
});



// WEBPACK FOOTER //
// ./static/js/collections/coach_list.js